






























































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { MissionStore } from '@/store'
import { ActiveMission } from '@/class'

export default Vue.extend({
  name: 'active-mission-landing',
  data: () => ({
    headers: [
      { text: 'Name', value: 'Mission.Name', align: 'left' },
      { text: 'Encounter', value: 'Encounter' },
      { text: 'Round', value: 'Round' },
      { text: 'Date Started', value: 'StartDate' },
      { text: '', value: 'Continue', align: 'right', sortable: false },
    ],
    availableHeaders: [
      { text: 'Name', value: 'Name', align: 'left' },
      { text: 'Encounters', value: 'Encounters' },
      { text: 'Labels', value: 'Labels' },
      { text: '', value: 'Start', align: 'right', sortable: false },
    ],
    completedHeaders: [
      { text: 'Name', value: 'Mission.Name', align: 'left' },
      { text: 'Date Started', value: 'StartDate' },
      { text: 'Date Finished', value: 'EndDate' },
      { text: 'Result', value: 'Result' },
      { text: '', value: 'Remove', align: 'right', sortable: false },
    ],
  }),
  computed: {
    availableMissions() {
      const store = getModule(MissionStore, this.$store)
      return store.Missions
    },
    activeMissions() {
      const store = getModule(MissionStore, this.$store)
      return store.ActiveMissions.filter(x => !x.IsComplete)
    },
    completedMissions() {
      const store = getModule(MissionStore, this.$store)
      return store.ActiveMissions.filter(x => x.IsComplete)
    },
  },
  created() {
    const store = getModule(MissionStore, this.$store)
    store.Missions.forEach(m => m.ValidateSteps())
  },
  methods: {
    deleteActiveMission(m: ActiveMission) {
      m.SaveController.delete()
    },
  },
})
